import React from 'react';

export const StarButton = ({ style }) => {
  // eslint-disable-next-line max-len
  const buttonIframe = '<iframe src="https://ghbtns.com/github-btn.html?user=flowwer-dev&repo=pull-request-stats&type=star&count=true&size=large" frameborder="0" scrolling="0" width="170" height="30" title="GitHub"></iframe>';

  return (
    // eslint-disable-next-line react/no-danger
    <div style={style} dangerouslySetInnerHTML={{ __html: buttonIframe }} />
  );
};
